import { render, staticRenderFns } from "./DuplicationButton.vue?vue&type=template&id=48b4b85b&"
import script from "./DuplicationButton.vue?vue&type=script&lang=js&"
export * from "./DuplicationButton.vue?vue&type=script&lang=js&"
import style0 from "./DuplicationButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
